import { Skeleton } from '@mui/material'
import React from 'react'
export const CounterSkeleton = () => {
  return (
    <>
      <div class={`rounded-xl bg-white border flex items-center justify-between p-4 shadow-sm`}>
        <div class="">
          <Skeleton width={65} />
          <Skeleton width={180} />
          <Skeleton width={100} />
        </div>
        <div class={`flex justify-center items-center rounded-full`}>
          <Skeleton width={55} height={55} variant="circular" />
        </div>
      </div>
    </>
  )
}
